module.exports = __webpack_public_path__ + "img/exit-icon.e85a04e6.svg";